import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import SimpleDropdown from '../../../../../components/Dropdowns/SimpleDropdown';

const PageNav = ({ pagesList = [], active, variant = 'nav', onChange }) => {
  if (variant === 'dropdown') {
    const options = pagesList.map(({ kpi_name }) => ({ value: kpi_name, label: kpi_name }));

    return (
      <SimpleDropdown
        selected={active}
        variant="light"
        options={options}
        disabled={options.length === 1}
        className="forecasts-page-nav__dropdown"
        onChange={onChange}
      />
    );
  }

  return (
    <nav className="reports-and-exports-page__nav">
      {pagesList.map(({ kpi_name }) => {
        const isActive = kpi_name === active;
        return (
          <a
            key={kpi_name}
            className={cx('reports-and-exports-page__nav-item', isActive && 'active')}
            data-placeholder={kpi_name}
            onClick={(e) => {
              e.preventDefault();
              !isActive && onChange(kpi_name);
            }}
          >
            {kpi_name}
          </a>
        );
      })}
    </nav>
  );
};

PageNav.propTypes = {
  pagesList: T.array,
  active: T.string,
  variant: T.oneOf(['nav', 'dropdown']),
  onChange: T.func.isRequired,
};

export default PageNav;
